package modysy.simulation.pp

/** Models an state transition rule inside a population protocol.
  *
  * @param startInitiator   the state of the agent initialising the interaction before the interaction
  * @param startRespondent  the state of the agent responding to the interaction before the interaction
  * @param resultInitiator  the state of the agent initialising the interaction after the interaction
  * @param resultRespondent the state of the agent responding the interaction after the interaction
  */
case class Rule(
    startInitiator: State,
    startRespondent: State,
    resultInitiator: State,
    resultRespondent: State,
    energyGainOnInteract: Int = 0
) {}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/pp/Rule.scala